import { RouteItem } from '@eastcoal/router/types/route'

import {
  INQUIRY_AUCTION_CREATE_PAGE_PATH,
  INQUIRY_AUCTION_LIST_PAGE_PATH
} from './constants/path'
import { INQUIRY_AUCTION_LIST_PAGE_UUID } from './constants/uuid'

export const inquiryAuctionRoute: RouteItem = {
  title: '询比价',
  hideChildrenInMenu: true,
  uuid: INQUIRY_AUCTION_LIST_PAGE_UUID,
  children: [
    {
      title: '询比价列表',
      path: INQUIRY_AUCTION_LIST_PAGE_PATH,
      Component: () => import('./List')
    },
    {
      title: '新增询比价',
      path: INQUIRY_AUCTION_CREATE_PAGE_PATH,
      Component: () => import('./Create')
    }
  ]
}
